.step1 {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

.textarea {
  min-height: 160px;
  font-family: var(--font-mono);
  font-size: var(--fs-sm);
  resize: vertical;
}

.hint {
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.step2 {
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
}

.errorBanner {
  padding: var(--sp-4) var(--sp-5);
  background: var(--error-bg);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius);
  color: var(--error);
  font-size: var(--fs-sm);
}

.errorBanner p {
  margin: 0;
}

.errorBanner p + p {
  margin-top: var(--sp-2);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
}

.cardLegend {
  padding: 0;
  width: 100%;
}

.includeLabel {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  font-size: var(--fs-lg);
  font-weight: 600;
  cursor: pointer;
}

.missingBanner {
  margin: 0;
  padding: var(--sp-3) var(--sp-4);
  background: var(--warn-bg);
  border: var(--bw) solid var(--warn-border);
  border-radius: var(--radius);
  color: var(--warn);
  font-size: var(--fs-sm);
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sp-5);
}

@media (max-width: 560px) {
  .row {
    grid-template-columns: 1fr;
  }
}

.field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.fieldWarn input,
.fieldWarn select {
  border-color: var(--warn-border);
  background: var(--warn-bg);
}

.moneyRow {
  display: flex;
  gap: var(--sp-3);
}

.moneyRow input {
  flex: 1 1 auto;
  min-width: 0;
}

.moneyRow select {
  flex: 0 0 auto;
  width: 6em;
}

.notes {
  margin: 0;
  padding-left: var(--sp-6);
  color: var(--text-2);
  font-size: var(--fs-sm);
  list-style: disc;
}

.notes li + li {
  margin-top: var(--sp-1);
}

/* ── Вкладки источника ────────────────────────────────────────────────── */
.tabs {
  display: flex;
  gap: var(--sp-2);
  border-bottom: 1px solid var(--border);
}

.tab {
  padding: var(--sp-3) var(--sp-4);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--text-2);
  font-size: var(--fs-md);
  font-weight: 500;
  cursor: pointer;
  /* Кольцо фокуса рисуется поверх обычного :focus-visible из global.css —
     радиус там же выключается снизу, чтобы не резать нижнюю границу вкладки. */
}

.tab:hover {
  color: var(--text);
}

.tabActive {
  color: var(--text);
  border-bottom-color: var(--focus);
}

.panel {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding-top: var(--sp-2);
}

/* ── Баннеры состояния источника ──────────────────────────────────────── */
.offBanner {
  margin: 0;
  padding: var(--sp-3) var(--sp-4);
  background: var(--surface-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.fallbackBanner {
  margin: 0;
  padding: var(--sp-3) var(--sp-4);
  background: var(--warn-bg);
  border: var(--bw) solid var(--warn-border);
  border-radius: var(--radius);
  color: var(--warn);
  font-size: var(--fs-sm);
}

/* ── Обзор результата ─────────────────────────────────────────────────── */
.reviewCaption {
  margin: 0;
  font-weight: 600;
}

.modelLine {
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.notesBlock {
  padding: var(--sp-4) var(--sp-5);
  background: var(--surface-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
}

.notesTitle {
  margin: 0 0 var(--sp-2);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-2);
}

.notesBlock .notes {
  padding-left: var(--sp-5);
}

/* ── Скриншот: перетаскивание, вставка из буфера, превью ────────────────── */
.dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-7) var(--sp-5);
  border: var(--bw) dashed var(--border-strong);
  border-radius: var(--radius-lg);
  background: var(--surface-2);
  text-align: center;
  color: var(--text-2);
  transition: border-color var(--dnd-dur) var(--dnd-ease), background var(--dnd-dur) var(--dnd-ease);
}

.dropzoneOver {
  border-color: var(--focus);
  background: var(--flight-bg);
}

@media (prefers-reduced-motion: reduce) {
  .dropzone {
    transition: none;
  }
}

/* Пачка скриншотов: сетка превью + строка с итогом и кнопками. Рамка та же
   пунктирная, что у пустой зоны, — бросать файлы можно и поверх пачки. */
.shots {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-4);
  border: var(--bw) dashed var(--border-strong);
  border-radius: var(--radius-lg);
  background: var(--surface-2);
  transition: border-color var(--dnd-dur) var(--dnd-ease), background var(--dnd-dur) var(--dnd-ease);
}

.shotsOver {
  border-color: var(--focus);
  background: var(--flight-bg);
}

@media (prefers-reduced-motion: reduce) {
  .shots {
    transition: none;
  }
}

.shotList {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.shot {
  position: relative;
  flex: 0 0 auto;
}

.shotImg {
  display: block;
  width: 96px;
  height: 128px;
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  object-fit: cover;
  object-position: top;
  background: var(--surface-sunken);
}

/* Номер повторяет нумерацию, которую видит модель, — по нему находится
   картинка, о которой она написала в заметках. */
.shotNum {
  position: absolute;
  top: var(--sp-2);
  left: var(--sp-2);
  min-width: 1.5em;
  padding: 0 var(--sp-1);
  border-radius: var(--radius);
  /* Тёмная плашка мимо темы: она лежит поверх чужой картинки, а не поверх
     нашего фона, и должна читаться на любом скриншоте. */
  background: rgb(0 0 0 / 0.65);
  color: #fff;
  font-size: var(--fs-sm);
  font-weight: 600;
  text-align: center;
}

.shotRemove {
  position: absolute;
  top: var(--sp-2);
  right: var(--sp-2);
  width: 1.6em;
  height: 1.6em;
  padding: 0;
  border: var(--bw) solid var(--border);
  border-radius: 50%;
  background: var(--surface);
  color: var(--text);
  font-size: var(--fs-md);
  line-height: 1;
  cursor: pointer;
}

.shotRemove:hover {
  background: var(--error-bg);
  border-color: var(--error-border);
  color: var(--error);
}

.shotErrors {
  margin: 0;
  padding: 0;
  list-style: none;
}

.shotErrors li + li {
  margin-top: var(--sp-1);
}

.previewMeta {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  min-width: 0;
}

.previewMeta p {
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.previewActions {
  display: flex;
  gap: var(--sp-3);
}
